import visit from '@/api/customer/location-visitation'

import { baseState, baseMutations } from '@/store/mixins'
import { uniqBy } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  visitStatus: '',
  salers: [],
  provinces: [],
  districts: [],
  communes: [],
  province_code: undefined,
  allProvinces: [],
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SALE(state, data) {
    state.salers = data
  },
  SET_PROVINCE_CODE(state, code) {
    state.province_code = code
  },
  SET_VISIT_STATUS(state, value){
    state.visitStatus = value
  },
  SET_ALL_PROVINCE(state, value){
    state.allProvinces = value
  },
  SET_ADDRESS(state, data) {
    state.provinces = uniqBy(
      data.map(
        el => ({ value: el.province_code, label: el.province_name_en })), 'value'
    )
    state.districts = uniqBy(
      data.map(
        el => ({
          value: el.district_code,
          label: el.district_name_en,
          province_code: el.province_code
        })
      ),
      'value'
    )
    state.communes = uniqBy(
      data.map(
        el => ({
          value: el.commune_code,
          label: el.commune_name_en,
          district_code: el.district_code
        })
      ),
      'value'
    )
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  CLEAR_RESOURCE_SETUP(state){
    state.provinces = []
    state.districts = []
    state.communes = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          province_code: context.state.province_code,
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ','),
          visit_status: context.state.visitStatus
        }
      },
      attrubutes
    )
    return visit.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return visit.store(data)
  },
  update(context, { id, data }) {
    return visit.update(id, data)
  },
  destroy(context, id) {
    return visit.destroy(id)
  },
  copy(context, data) {
    return visit.copy(data)
  },
  importPlane(context, data) {
    return visit.importPlane(data)
  },
  viewMap(context, data) {
    return visit.viewMap(data)
  },
  async getAddress(context, id) {
    let add = await visit.address(id)
    context.commit('SET_ADDRESS', add.data)
    return add
  },
  async fetchResources(context) {
    let sale = await visit.user()
    context.commit('SET_SALE', sale.data)
  },
  async getProvince(context){
    if(!context.state.allProvinces.length)
    {
      let response = await  visit.product()
      context.commit('SET_ALL_PROVINCE', response.data)
    }
  }
}
